import { inject } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';

import { ContentfulMarkdown } from 'common/components';
import { useClassName } from 'common/hooks';
import { CircleParking } from 'public/icons';

import { VenueHoursCustom } from '../Custom/Hours';
import useCustomStyle from '../../hooks';
import Center from '../Center';

import './property-info.less';

export default inject('property')(function PropertyInfo({
  property,
  component,
}) {
  const classNames = useClassName('CLPPropertyInfo');
  const [venue, setVenue] = useState(null);
  const [setRef, style] = useCustomStyle(component.fields.settings);

  const title = style['--title'];
  const description = style['--description'];
  const directions = style['--directions'];
  const theme = style?.['--theme'] || 'light';

  useEffect(() => {
    property
      .fetchOpeningHours(DateTime.now().toISODate(), 'retail')
      .then((venue) => {
        setVenue(venue);
      });
  }, []);

  if (!venue) return null;

  return (
    <Center className={classNames('container')} ref={setRef}>
      <div className={classNames('title')}>
        <span>{title}</span>
      </div>
      <div className={classNames('description-and-hours')}>
        <div className={classNames('description')}>{description}</div>

        <div className={classNames('info')}>
          <VenueHoursCustom venue={{ openingHours: venue }} theme={theme} />
          <div className={classNames('directions')}>
            <CircleParking />
            <ContentfulMarkdown
              className={classNames('directions-text')}
              field={{ 'en-US': directions }}
            />
          </div>
        </div>
      </div>
    </Center>
  );
});
